import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useSupportTicketOverview({
  enabled = true,
}: {
  enabled?: boolean;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['supportTicket/overview'], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: 'supportTicket/overview',
      });
      return res;
    },
    enabled,
  });
}
